import React, { useState, useEffect } from 'react';
import "../style/index.css"
import { useNavigate } from "react-router-dom";



export default function MainPage() {
  // --- State Architecture ---
  const [currency, setCurrency] = useState('USD');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isDialing, setIsDialing] = useState(false);
  
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [countryCode, setCountryCode] = useState('+1');
  const [phoneNumber, setPhoneNumber] = useState('');
const [showPopup,setShowPopup] = useState(false);
const openPopup = () => {
  setShowPopup(true);
};
const navigate = useNavigate();
  // --- Pricing Models ---
  const pricingData = [
    {
      title: "Free",
      desc: "For solo founders starting out.",
      prices: { USD: "$0", INR: "₹0" },
      features: [
        { text: "5 Invoices / month", included: true },
        { text: "Auto-reminders", included: false },
        { text: "Custom Branding", included: false }
      ],
      cta: "Get Started",
      popular: false
    },
    {
      title: "Starter",
      desc: "Everything you need to scale.",
      prices: { USD: "$6.01", INR: "₹499" },
      features: [
        { text: "5 Invoices / month", included: true },
        { text: "AI Voice Support", included: true },
        { text: "Auto-reminders", included: true },
        { text: "Multi-currency", included: true }
      ],
      cta: "Try Starter",
      popular: true
    },
    {
      title: "Pro",
      desc: "Unlimited power for agencies.",
      prices: { USD: "$18.06", INR: "₹1499" },
      features: [
        { text: "Unlimited Invoices", included: true },
        { text: "Custom Voice Agent", included: true },
        { text: "White-label PDF", included: true },
        { text: "Priority API Access", included: true }
      ],
      cta: "Go Unlimited",
      popular: false
    }
  ];

  // --- Intersection Animation Listeners ---
  useEffect(() => {
    const observerOptions = { threshold: 0.1 };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, observerOptions);

    const revealElements = document.querySelectorAll('.reveal');
    revealElements.forEach((el) => observer.observe(el));

    return () => {
      revealElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  // --- Action Form Processing ---
  const handleCallRequest = (e) => {
    e.preventDefault();
    setIsDialing(true);

    setTimeout(() => {
      setIsDialing(false);
      setFormSubmitted(true);
    }, 3000);
  };

 
  return (
    <>
      {/* Top Navigation Bar */}
      <nav className="navbar">
        <div className="nav-brand font-display-heading">Invoice AI</div>
        <div className="nav-links">
          <a className="nav-link" href="#features">Features</a>
          <a className="nav-link" href="#how-it-works">How it Works</a>
          <a className="nav-link" href="#pricing">Pricing</a>
          <a className="nav-link" href="#architecture">Architecture</a>
        </div>
        <button className="btn-primary"  onClick={() => navigate("/login")}>
          Get Started
        </button>
        
      </nav>
 
<div className="dev-banner">
  🚧 Site Development In Progress
</div>
 {showPopup && (
  <div className="popup-overlay">
    <div className="popup-card">
      <button
        className="close-btn"
        onClick={() => setShowPopup(false)}
      >
        ✕
      </button>

      <img
        src="https://img.freepik.com/free-vector/programmer-concept-illustration_114360-2284.jpg"
        alt="Developer"
        className="popup-avatar"
      />

      <h2>Development In Progress</h2>

      <p>
        Thank you for your interest in Invoice AI.
        Our development team is currently enhancing
        features, security, and user experience.
      </p>

      <p>
        The platform is actively being engineered by
        <strong> Vishal Rathod </strong>
        and new capabilities will be released soon.
      </p>

      <button
        className="btn-primary"
        onClick={() => setShowPopup(false)}
      >
        Got It
      </button>
    </div>
  </div>
)}
      {/* Hero Header Space */}
      <header className="container-max hero-grid">
        <div className="reveal active">
          <div className="badge-tag">
            <span className="material-symbols-outlined">verified</span>
            by vrsafetech
          </div>
          <h1 className="hero-title font-display-heading">
            Create Invoices Instantly, Just by Making a <span>Phone Call.</span>
          </h1>
          <p className="hero-desc">
            Call our dedicated US AI-number, speak naturally, and let our voice agent generate, format, and send your invoices in real-time.
          </p>
          <div className="hero-actions">
            <button className="btn-hero-primary"  onClick={openPopup}>
              Try for Free
            </button>
            <button className="btn-hero-outline"  onClick={openPopup}>
              <span className="material-symbols-outlined">play_circle</span>
              Watch Demo Video
            </button>
          </div>
        </div>

        <div className="hero-right reveal active">
          <div className="glass-card premium-shadow">
            <div className="phone-mockup">
              <div className="phone-header">
                <div className="phone-user">
                  <div className="phone-avatar">
                    <span className="material-symbols-outlined">call</span>
                  </div>
                  <div>
                    <p className="avatar-sub">Invoice AI Agent</p>
                    <p className="avatar-main">Calling +1 (318) 2397679</p>
                  </div>
                </div>
                <span className="material-symbols-outlined">more_vert</span>
              </div>
              <div className="phone-body">
                <div className="mic-container">
                  <div className="mic-pulse"></div>
                  <div className="mic-button">
                    <span className="material-symbols-outlined">mic</span>
                  </div>
                </div>
                <p className="voice-text font-display-heading">"Hey, create an invoice for John Doe..."</p>
                <p className="voice-status">Processing voice to PDF...</p>
              </div>
            </div>
          </div>
          
          <div className="floating-card glass-card premium-shadow">
            <div className="float-header">
              <span className="material-symbols-outlined">task_alt</span>
              <span className="float-title">Invoice #4202 Generated</span>
            </div>
            <p className="float-sub">Sent to john@doe.com</p>
            <div className="float-footer">
              <span className="float-price font-display-heading">$1,250.00</span>
              <span className="float-action">View PDF</span>
            </div>
          </div>
        </div>
      </header>

      {/* Process Sequence */}
      <section className="section-padding section-bg-light" id="how-it-works">
        <div className="container-max">
          <div className="section-center-head reveal active">
            <h2 className="section-title font-display-heading">Invoice in 3 Easy Steps</h2>
            <p className="section-subtitle">The fastest billing workflow ever engineered.</p>
          </div>
          <div className="steps-grid">
            <div className="step-card premium-shadow reveal active">
              <div className="step-icon-box">
                <span className="material-symbols-outlined">call</span>
              </div>
              <h3 className="step-heading font-display-heading">1. Dial US Number</h3>
              <p className="step-desc">Call our toll-free dedicated AI billing line from anywhere in the world.</p>
            </div>
            <div className="step-card step-card-active premium-shadow reveal active">
              <div className="step-icon-box">
                <span className="material-symbols-outlined">record_voice_over</span>
              </div>
              <h3 className="step-heading font-display-heading">2. Speak Naturally</h3>
              <p className="step-desc">Tell the AI what to bill. No codes, no formatting, just plain conversation.</p>
            </div>
            <div className="step-card premium-shadow reveal active">
              <div className="step-icon-box">
                <span className="material-symbols-outlined">outgoing_mail</span>
              </div>
              <h3 className="step-heading font-display-heading">3. Sent Instantly</h3>
              <p className="step-desc">The AI formats the PDF and emails it to your client before you hang up.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Structural System Capabilities */}
      <section className="section-padding" id="features">
        <div className="container-max features-grid">
          <div className="feature-large-card reveal active">
            <div>
              <span className="material-symbols-outlined">spatial_audio_off</span>
              <h3 className="feature-large-title font-display-heading">AI Voice Billing</h3>
              <p className="feature-large-desc">Experience true hands-free billing. Our LLM-powered voice agents understand context, quantities, and client names with 99.9% accuracy.</p>
            </div>
            <div className="feature-badge-row">
              <div className="tech-tag">Whisper-v3</div>
              <div className="tech-tag">GPT-4o Voice</div>
            </div>
          </div>
          
          <div className="feature-small-card premium-shadow reveal active">
            <span className="material-symbols-outlined">currency_exchange</span>
            <h4 className="feature-small-title font-display-heading">Multi-Currency</h4>
            <p className="feature-small-desc">Engineered specifically for global operations with seamless USD ($) and INR (₹) support.</p>
          </div>
          
          <div className="feature-small-card premium-shadow reveal active">
            <span className="material-symbols-outlined">notifications_active</span>
            <h4 className="feature-small-title font-display-heading">Auto Follow-ups</h4>
            <p className="feature-small-desc">AI-driven polite reminders sent to clients for pending payments automatically.</p>
          </div>

          <div className="feature-wide-card reveal active">
            <div className="wide-card-flex">
              <div className="wide-card-info">
                <h3 className="feature-large-title font-display-heading">Analytics Dashboard</h3>
                <p className="feature-small-desc">Track your revenue growth with real-time visualized data. See exactly how your phone calls are turning into cash.</p>
                <div className="metrics-row">
                  <div>
                    <p className="metric-label">Paid</p>
                    <p className="metric-value font-display-heading">82%</p>
                  </div>
                  <div>
                    <p className="metric-label">Pending</p>
                    <p className="metric-value font-display-heading">15%</p>
                  </div>
                  <div>
                    <p className="metric-label">Overdue</p>
                    <p className="metric-value font-display-heading">3%</p>
                  </div>
                </div>
              </div>
              
              <div className="wide-card-chart premium-shadow">
                <div className="graph-container">
                  <div className="graph-bar" style={{ height: '60%' }}></div>
                  <div className="graph-bar" style={{ height: '80%' }}></div>
                  <div className="graph-bar active-bar" style={{ height: '100%' }}></div>
                  <div className="graph-bar" style={{ height: '70%' }}></div>
                  <div className="graph-bar" style={{ height: '90%' }}></div>
                  <div className="graph-bar" style={{ height: '50%' }}></div>
                  <div className="graph-bar" style={{ height: '95%' }}></div>
                </div>
                <div className="graph-labels">
                  <span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Financial Matrix Models */}
      <section className="section-padding section-bg-white" id="pricing">
        <div className="container-max">
          <div className="section-center-head reveal active">
            <h2 className="section-title font-display-heading">Simple, Transparent Pricing</h2>
            <div className="toggle-wrapper">
              <button 
                type="button" 
                onClick={() => setCurrency('USD')} 
                className={`toggle-btn ${currency === 'USD' ? 'active' : ''}`}
              >
                USD ($)
              </button>
              <button 
                type="button" 
                onClick={() => setCurrency('INR')} 
                className={`toggle-btn ${currency === 'INR' ? 'active' : ''}`}
              >
                INR (₹)
              </button>
            </div>
          </div>

          <div className="pricing-grid">
            {pricingData.map((plan, idx) => (
              <div 
                key={idx} 
                className={`pricing-card reveal ${plan.popular ? 'pricing-card-popular premium-shadow' : ''}`}
              >
                {plan.popular && (
                  <div className="popular-badge">MOST POPULAR</div>
                )}
                <h3 className="plan-title font-display-heading">{plan.title}</h3>
                <p className="plan-desc">{plan.desc}</p>
                <div className="price-block">
                  <span className="price-amount font-display-heading">{plan.prices[currency]}</span>
                  <span className="price-currency">/mo</span>
                </div>
                <ul className="features-list">
                  {plan.features.map((feat, fIdx) => (
                    <li key={fIdx} className={feat.included ? 'included' : 'excluded'}>
                      <span className="material-symbols-outlined">
                        {feat.included ? 'check_circle' : 'cancel'}
                      </span>
                      {feat.text}
                    </li>
                  ))}
                </ul>
                <button 
                  type="button" 
                  className={`btn-plan ${plan.popular ? 'btn-plan-popular' : ''}`}  onClick={openPopup}
                >
                  {plan.cta}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Active Communication Gateway Form */}
      <section className="section-padding section-bg-alt">
        <div className="container-max split-form-layout">
          <div className="form-info-side reveal active">
            <h2 className="section-title font-display-heading">Experience the Magic: Get a Call from Our AI</h2>
            <p>Want to see how it works? Enter your details below, and our AI agent will call you within 10 seconds to walk you through a live demo.</p>
            <div className="form-status-badge premium-shadow">
              <div className="badge-icon-circle">
                <span className="material-symbols-outlined">phone_in_talk</span>
              </div>
              <div>
                <p className="badge-headline">Ready to Dial</p>
                <p className="badge-subtext">Available for US and India numbers</p>
              </div>
            </div>
          </div>
          
          <div className="form-wrapper-side reveal active">
            {/* <form className="interactive-form premium-shadow" onSubmit={handleCallRequest}> */}
              <form
  className="interactive-form premium-shadow"
  onSubmit={(e)=>{
    e.preventDefault();
    openPopup();
  }}
>
              <div className="form-group">
                <label>Full Name</label>
                <input 
                  type="text" 
                  value={fullName} 
                  onChange={(e) => setFullName(e.target.value)} 
                  className="form-input" 
                  placeholder="Vishal Rathod" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Email Address</label>
                <input 
                  type="email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  className="form-input" 
                  placeholder="vishal@vrsafetech.com" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <div className="phone-input-container">
                  <select 
                    value={countryCode} 
                    onChange={(e) => setCountryCode(e.target.value)} 
                    className="country-select"
                  >
                    <option value="+1">+1</option>
                    <option value="+91">+91</option>
                  </select>
                  <input 
                    type="tel" 
                    value={phoneNumber} 
                    onChange={(e) => setPhoneNumber(e.target.value)} 
                    className="form-input" 
                    placeholder="555-000-0000" 
                    required 
                  />
                </div>
              </div>
              
              <button 
                type="submit" 
                disabled={isDialing || formSubmitted} 
                className="btn-submit"
              >
                {isDialing ? (
                  <>
                    <svg className="spinner" viewBox="0 0 50 50">
                      <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="4"></circle>
                    </svg>
                    Dialing your number via AI...
                  </>
                ) : formSubmitted ? (
                  <>
                    <span className="material-symbols-outlined">check</span> Call Connected
                  </>
                ) : (
                  "Call Me Now"
                )}
              </button>
              <p className="form-disclaimer">By clicking "Call Me Now" you agree to be contacted by our automated AI agent.</p>
            </form>
          </div>
        </div>
      </section>

      {/* Core Systems & Management Node */}
      <section className="section-padding container-max" id="architecture">
        <div className="reveal active">
          <h2 className="section-title text-center font-display-heading" style={{ textAlign: 'center', marginBottom: '4rem' }}>Behind the Architecture</h2>
          <div className="architecture-box">
            <div className="avatar-frame">
              <img 
                alt="Vishal Rathod" 
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuARjN3qmzrFsX0J0ydNle9nhIxxRfhY4PJr90TdzsoiaIbqpD_ZjDtTUHZTfH2Xk40G2M2Q7YNwAGZgab4Fq9ALSU1nbqFV6diQV4E4Bu1yt-ypzFXc2UxLDZfjh4gC0_G8EK55DXkha4tUFgdTvOZ5sFiBX7RCAjsBbs52izPW8JoBxQOvamy3cJKwq8lARAi3RD8L3q55h_-1JNaJeL0YwHww9LRc4u1tG3riCYioyz1MitZFeDSsPKjK7hOu82BzyW3frBVV75pI" 
              />
            </div>
            <div className="architecture-content">
              <div className="role-badge">FOUNDER & ARCHITECT</div>
              <h3 className="font-display-heading">Vishal Rathod</h3>
              <p>
                As a solo founder and full-stack AI developer, my goal was to eliminate the friction between business operations and billing. Invoice AI is engineered at the intersection of LLM voice integration and financial security. We leverage secure voice pipelines to ensure your financial data is processed in real-time without ever leaving an encrypted environment.
              </p>
              <div className="stats-grid">
                <div className="stat-item">
                  <h4 className="font-display-heading">99.9%</h4>
                  <p>Uptime</p>
                </div>
                <div className="stat-item">
                  <h4 className="font-display-heading">&lt; 200ms</h4>
                  <p>Latency</p>
                </div>
                <div className="stat-item">
                  <h4 className="font-display-heading">AES-256</h4>
                  <p>Encryption</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Structural Terminus */}
      <footer className="site-footer">
        <div className="container-max footer-flex">
          <div className="footer-logo-area">
            <span className="footer-logo">Invoice AI</span>
            <p className="footer-tagline">Engineered by Vishal Rathod for modern businesses.</p>
          </div>
          <div className="footer-links">
            <a className="footer-link" href="#privacy">Privacy Policy</a>
            <a className="footer-link" href="#terms">Terms of Service</a>
            <a className="footer-link" href="#attribution">Developer Attribution</a>
          </div>
          <p className="footer-copy">© 2026 Invoice AI by vrsafetech. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
}